import state from "./state";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state,
  getters,
  actions,
  mutations,
  strict: process.env.NODE_ENV === "development",
};
